const axios = require('axios').default;

export default async function FetchStats() {
  let form_data = new FormData;
  form_data.append('action', 'get_available_stats');
  return await axios.post('/wp-admin/admin-ajax.php', form_data).then(response => {
    return response.data;
  });
}